import * as React from "react";
import { Button } from "./Button";
import "./ButtonIcon.scss";

export enum ButtonIcons {
  Verwijderen = "verwijderen",
  Wijzigen = "wijzigen",
  Download = "download"
}

export interface ButtonIconProps {
  icon: ButtonIcons;
  buttonText: string;
  id?: string;
  disabled?: boolean;
  clickHandler?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const ButtonIcon = (props: ButtonIconProps) => {
  return (
    <Button
      buttonText={props.buttonText}
      id={props.id}
      clickHandler={props.clickHandler}
      type={"button"}
      disabled={props.disabled}
      layout={"transparent"}
      beforeTextChildren={() => {
        return <span className={`btn__icon btn__icon--${props.icon}`} />;
      }}
    />
  );
};
